import { createSelector } from '@ngrx/store';
import { buildingsList } from '@layout/state/layout.selectors';
import { IBuilding } from '@shared/interfaces/building.interfaces';
import { IAssetState } from './area-assets.reducer';

export const selectAssetsState = (state: { assets: IAssetState }) => state.assets;

export const isAssetsFilterOpened = createSelector(
	selectAssetsState,
	assets => assets.filterOpened
);
export const getAssetsBuildingsFiltersState = createSelector(
	selectAssetsState,
	assets => assets.assetsBuildingsFilterState
);
export const getFloorsWithRoomsByBuildingId = (buildingId: string) =>
	createSelector(buildingsList, (buildings: IBuilding[]) => {
		if (!buildings) {
			return;
		}

		return buildings.find(building => building.id === buildingId).floor;
	});
